

const PreviewDesktop = (props) => {
  const { title, text, icon, img, linkLabel, primaryCTAtype, buttonDeeplinkingLabel, buttonActionLabel, buttonSecondaryLabel, triggerTimelineTemplateId } =
    props.values;
  return (
    <>
      { triggerTimelineTemplateId && triggerTimelineTemplateId !== 'DEFAULT'
          ?
            <div className="dark-background noPadding">
              <img
                className="iosi-mock activation"
                src={
                  triggerTimelineTemplateId === 'SUBSCRIBE_IOSI_PLUS' ? './images/iosi-activation.png' :
                  triggerTimelineTemplateId === 'RENEW_IOSI_PLUS' ? './images/iosi-renewal.png' :
                  triggerTimelineTemplateId === 'SUBSCRIBE_IOSI_START' ? './images/iosi-activation-start.png' :
                  triggerTimelineTemplateId === 'RENEW_IOSI_START' ? './images/iosi-renewal-start.png' :
                  '' // TO DO CHECK SE VA BENE
                }                
                alt="" />
            </div>
          :
          <div className="dark-background">
          <div className="popup-container">
            <div className={`popup-header ${img ? 'with-img' : 'no-img'}`}>
              {img && (
                <img
                  className="img"
                  src={img}
                  alt=""
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src =
                      'https://via.placeholder.com/1680x750';
                  }}
                />
              )}
              {icon &&
                <img
                  className="popup-icon"
                  src={icon}
                  alt=""
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src =
                      'https://via.placeholder.com/100x100';
                  }}
                />
              }
            </div>
            <div className="popup-content">
              {title && <h2 dangerouslySetInnerHTML={{__html: props.values.title}} className="popup-title"></h2>}
              {text && <p dangerouslySetInnerHTML={{__html: text}} className="popup-text"></p>}
              {linkLabel && <span className="popup-link">{linkLabel}</span>}
            </div>
            <div className="popup-actions">
            {props.values.primaryCTAtype === 'DL' ?
              buttonDeeplinkingLabel &&
                <button className="button button--primary">{buttonDeeplinkingLabel}</button>
              
              :
              buttonActionLabel && (
                <button className="button button--primary">{buttonActionLabel}</button>
              )
            }
              {buttonSecondaryLabel && (
                <button className="anchor">{props.values.buttonSecondaryLabel}</button>
              )}
            </div>
          </div>
        </div>
      }
    </>
  );
};
export default PreviewDesktop;
